import { useMutation } from "@tanstack/react-query";
import { discountService } from "..";
import { CalculateGroupDiscountSmsAmountPayload } from "../type";

type Props = {
  setAmount?: (e: number) => void;
  setOpenAmount: () => void;
  setSmsCount?: (e: number) => void;
};

function useCalculateDiscountAmount({
  setAmount,
  setOpenAmount,
  setSmsCount,
}: Props) {
  return useMutation({
    mutationFn: (command: CalculateGroupDiscountSmsAmountPayload) => {
      return discountService.calculateDiscountAmount(command);
    },
    onSuccess(data) {
      if (setAmount) setAmount(data?.sumAmount || 0);
      if (setSmsCount) setSmsCount(data?.smsCount || 0);
      setOpenAmount();
    },
  });
}

export default useCalculateDiscountAmount;
